import api from '../../../api/index';

export default {
  register({}, value) {
    return api.post('/professional', value);
  },
  consultCep({}, cep) {
    return api.get(`cep/${cep}/consult`);
  },
  registerAssinatura({}, value) {
    return api.post('/professional/assinatura', value);
  },
  verifyPaymentAppPix({}, fatura) {
    return api.get(`/professional/verify-payment-pix/${fatura}`);
  },
  showInfoAssinatura({ rootGetters }, id) {
    return api.get('payment/split/info-assinatura-profissional/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  showFaturaId({ rootGetters }, id) {
    return api.get('payment/split/info-fatura/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  expiredFaturaId({ rootGetters }, id) {
    return api.get('payment/split/expired-fatura/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  contractFreePlan({ rootGetters }, professionalId) {
    return api.post(
      'professional/contract/free',
      { id: professionalId },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getReports({ rootGetters }) {
    return api.get('professional/reports-all', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  execReport({ rootGetters }, value) {
    return api.post('professional/reports-exec', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAllIndicated({ rootGetters, commit }) {
    return api
      .get('professional/indicated', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setIndicatedProfessionals', response.data.data);
      });
  },
  getIndicated({ rootGetters, commit }, indicatedProfessionalId) {
    return api
      .get(`professional/indicated/${indicatedProfessionalId}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setIndicatedProfessional', response.data.data);
      });
  },
  saveSocialMedias({ rootGetters }, value) {
    return api.post('/professional/social-medias', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getSocialMedias({ rootGetters }, professionalId) {
    return api.get(`/professional/social-medias/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveBanner({ rootGetters }, data) {
    return api.post('/professional/website/banner', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getBanner({ rootGetters }, professionalId) {
    return api.get(`/professional/website/banner/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listBanner({ rootGetters }, professionalId) {
    return api.get(`/professional/website/banners/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteBanner({ rootGetters }, professionalId) {
    return api.delete(`/professional/website/banner/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveCustomization({ rootGetters }, data) {
    return api.post('/professional/website/customization', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getCustomization({ rootGetters }, professionalId) {
    return api.get(`/professional/website/customization/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getWebsiteSolicitationStatus({ rootGetters }, professionalId) {
    return api.get(`/professional/website/solicitation/status/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarValorAssinatura({ rootGetters }, id) {
    return api.get(`profissional/buscar-valor-assinatura/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  efetuarPagamentoSite({ rootGetters }, data) {
    return api.post('profissional/efetuar-pagamento-assinatura-site', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
